/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
/* eslint-disable camelcase */
/* eslint-disable react/function-component-definition */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable no-plusplus */
import React, { useEffect, useState } from 'react';
import { Modal, message, Button, Table, Input, Tag, Tooltip, Popconfirm } from 'antd';
import moment from 'moment';
import UilCheck from '@iconscout/react-unicons/icons/uil-check';
import UilTimes from '@iconscout/react-unicons/icons/uil-times';
import CourseForm from './UpdateCourse';
import { DataService } from '../../../config/dataService/dataService';
import { BtnWithIcon, TableWrapper } from '../../../container/styled';
import { TRAINING_STATUS_COLORS, TRAINING_STATUSES } from '../../../config/config';

const FormDialog = ({ showDialog, editId, setReloadParrent }) => {
  const [busy, setBusy] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [courseData, setCourseData] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [reload, setReload] = useState(false);

  const fetchTableData = async () => {
    try {
      setBusy(true)
      const response = await DataService.post('/emp-training/get-training-by-id', { training_id: editId });
      const { data } = response.data;
      setTableData(data);
      setBusy(false)
    } catch (error) {
      message.error(`Error fetching table data:  ${error.message}`)
      setBusy(false)
    }
  };

  useEffect(() => {
    if (editId) {
      fetchTableData();
    }
    if (reload) setReload(false)
  }, [editId, reload]);

  const handleUpdateCourseClick = async (event) => {
    try {
      const { currentTarget } = event;
      const dataID = Number(currentTarget.getAttribute('data-index') || 0)
      const dbRec = tableData.find(item => item.id === dataID);
      if (dbRec) {
        setCourseData(dbRec)
        setShowForm(true)
      }
    } catch (error) {
      message.error(`Error sending request:  ${error.message}`)
    }
  }

  const handlePassClick = async (event) => {
    try {
      setBusy(true)
      const { currentTarget } = event;
      const dataID = Number(currentTarget.getAttribute('data-index') || 0)

      const response = await DataService.post('/emp-training/update-training-trainings', {
        training_id: dataID,
        status_id: TRAINING_STATUSES.COMPLETED
      });
      const { status } = response.data;
      setBusy(false)
      if (status) {
        message.success(response.data.message);
        setReload(true)
        if(setReloadParrent) setReloadParrent(true)
      } else { message.error(`Error in submitting request:  ${response.data.message}`) }

    } catch (error) {
      message.error(`Error sending request:  ${error.message}`)
    }
  }

  const handleFailClick = async (event) => {
    try {
      setBusy(true)
      const { currentTarget } = event;
      const dataID = Number(currentTarget.getAttribute('data-index') || 0)

      const response = await DataService.post('/emp-training/update-training-trainings', {
        training_id: dataID,
        status_id: TRAINING_STATUSES.FAILED
      });
      const { status } = response.data;
      setBusy(false)
      if (status) {
        message.success(response.data.message);
        setReload(true)
        setReloadParrent(true)
      } else { message.error(`Error in submitting request:  ${response.data.message}`) }

    } catch (error) {
      message.error(`Error sending request:  ${error.message}`)
    }
  }

  const TableColumns = [
    {
      title: 'Course Name',
      dataIndex: 'course_name',
      key: 'course_name',
      field: 'course_name',
      export: true,
    },
    {
      title: () => {
        return (
          <div className='flex'>
            Center Name
          </div>
        )
      },
      dataIndex: 'center_name',
      key: 'center_name',
      field: 'center_name',
      export: true,
    },
    {
      title: 'StartedAt',
      dataIndex: 'start_date_time',
      key: 'start_date_time',
      field: 'start_date_time',
      onCell: () => ({ className: 'w-20' }),
      export: true,
      render: (start_date_time) => {
        if (!start_date_time) return <p >NOT DEFINED</p>
        return <p >{moment(start_date_time).format('YYYY-MM-DD hh:mm a')}</p>
      },
    },
    {
      title: 'EndedAt',
      dataIndex: 'end_date_time',
      key: 'end_date_time',
      field: 'end_date_time',
      onCell: () => ({ className: 'w-20' }),
      export: true,
      render: (end_date_time) => {
        if (!end_date_time) return <p >NOT DEFINED</p>
        return <p >{moment(end_date_time).format('YYYY-MM-DD hh:mm a')}</p>
      },
    },
    {
      title: () => {
        return (
          <div className='flex justify-center'>
            Status
          </div>
        )
      },
      dataIndex: 'training_status',
      key: 'training_status',
      field: 'training_status',
      onCell: () => ({ className: 'w-20' }),
      export: true,
      render: (training_status) => {
        training_status = Number(training_status);
        try {
          const { color, label } = TRAINING_STATUS_COLORS[training_status]
          return (
            <div className="flex justify-content-center">
              <div className='taglist-wrap select-none'>
                <Tag color={color}>{label}</Tag>
              </div>
            </div>
          )
        } catch (error) {
          return <p>Undefined</p>
        }
      },
    },
    {
      title: 'Actions',
      export: false,
      width: 70,
      render: (rowData) => {
        // console.log('rowData', rowData)
        return (<div className='flex flex-row justify-center select-none'>
          {
            (Number(rowData.training_status) === TRAINING_STATUSES.IN_PROCESS) && <>

              <Tooltip title='Make Completed' className='select-none'>
                <Popconfirm
                  title="Are you sure mark this training as passed ?"
                  onConfirm={handlePassClick}
                  okButtonProps={{
                    'data-index': rowData.id
                  }}
                  // onCancel={cancel}
                  okText="Yes"
                  cancelText="No"
                >
                  <BtnWithIcon className='ninjadash-delete'>
                    <UilCheck
                      className='hover:scale-110 hover:text-green-400 hover:cursor-pointer transform transition duration-300 ease-in-out'
                      size={20}
                    />
                  </BtnWithIcon>
                </Popconfirm>
              </Tooltip>
              <Tooltip title='Make Rejected' className='select-none'>
                <Popconfirm
                  title="Are you sure mark this training as failed ?"
                  onConfirm={handleFailClick}
                  okButtonProps={{
                    'data-index': rowData.id
                  }}
                  // onCancel={cancel}
                  okText="Yes"
                  cancelText="No"
                >
                  <BtnWithIcon className='ninjadash-delete'>
                    <UilTimes
                      className='hover:scale-110 hover:text-red-400 hover:cursor-pointer transform transition duration-300 ease-in-out'
                      size={20}
                    />
                  </BtnWithIcon>
                </Popconfirm>
              </Tooltip>
            </>
          }

        </div >
        )
      },
    },
  ];

  return (
    <Modal
      open
      title='Training Courses Employee Enrolled In'
      cancelText="Cancel"
      width="70%"

      // onCancel={() => showDialog(false)}
      // onOk={() => form.submit()}
      centered
      footer={[
        <Button key="cancel" loading={busy} onClick={() => showDialog(false)} disabled={busy}>
          Close
        </Button>,
      ]}
      cancelButtonProps={{ disabled: busy }}
      destroyOnClose
    >

      <div className="ninjadasj-datatable mh-[50%]"
        style={{ minHeight: 'calc(100vh - 300px)' }}
      >
        <TableWrapper>
          <Table
            rowKey={(record) => `${record.id}`} // Generate a unique key for each row
            loading={busy}
            bordered
            virutal
            size='middle'
            className='border rounded drop-shadow-sm'
            pagination={false}
            // rowSelection='multiple'
            dataSource={tableData}
            columns={TableColumns}
            scroll={{ y: 'calc(100vh - 300px)' }} // Adjust height based on dialog size
          />
        </TableWrapper>
        {showForm && <CourseForm
          showDialog={() => { setShowForm(false); setCourseData(null) }}
          courseData={courseData}
          setReload={setReload}
          setReloadParrent={setReloadParrent}
        />}
      </div>
    </Modal>
  );
};

export default FormDialog;
